import { render, staticRenderFns } from "./Direction.vue?vue&type=template&id=67913d94&"
import script from "./Direction.vue?vue&type=script&lang=js&"
export * from "./Direction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports